export function getdata() {
	let obj = {
		headData: [{
				title: '领用发票起始号码',
				prop: 'invoiceBegin',
				width: '220',
				issort: true,
			},
			{
				title: '领用发票终止号码',
				prop: 'invoiceEnd',
				width: '220',
				issort: true,
			},
			{
				title: '领用数量',
				prop: 'receiveCount',
				width: '120',
				issort: true,
				align: "right"
			},
			{
				title: '库存发票起始号码',
				prop: 'inventoryInvoiceBegin',
				width: '220',
				issort: true,
			},
			{
				title: '库存发票终止号码',
				prop: 'inventoryInvoiceEnd',
				width: '220',
				issort: true,
			},
			{
				title: '库存数量',
				prop: 'inventoryCount',
				width: '120',
				issort: true,
				align: "right"
			},
			{
				title: '是否当年发票',
				prop: 'thatYearInvoice',
				width: '180',
				showFilter: true,
				custom: true,
				checkList: ['0', '1'],
				dataList: [{
						name: "是",
						code: "0"
					},
					{
						name: "否",
						code: "1"
					},
				]
			},
			{
				title: '申请领用时间',
				prop: 'applyDate',
				width: '180',
				showFilter: true,
				filterType: "daterange",
				checkList: [],
				custom: true,
			},
			{
				title: '领用结果',
				prop: 'applyResult',
				width: '120',
				showFilter: true,
				custom: true,
				checkList: ['0', '1'],
				dataList: [{
						name: "成功",
						code: "1"
					},
					{
						name: "失败",
						code: "0"
					},
				]
			},
			{
				title: '错误说明',
				prop: 'errorInfo',
				issort: true,
				width: '120',
			},
			{
				title: '操作',
				prop: 'cz',
				width: '120',
				fixed: "right",
				custom: true,
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
